<template>
  <div class="expense-page">
    <h2>Pengeluaran</h2>

    <form @submit.prevent="addTransaction" class="transaction-form">
      <h3>Tambah Pengeluaran Baru</h3>
      <div class="form-group">
        <label for="expense-date">Tanggal:</label>
        <input type="date" id="expense-date" v-model="newTransaction.date" required>
      </div>
      <div class="form-group">
        <label for="expense-description">Deskripsi:</label>
        <input type="text" id="expense-description" v-model="newTransaction.description" placeholder="Belanja, transportasi, dll." required>
      </div>
      <div class="form-group">
        <label for="expense-amount">Jumlah:</label>
        <input type="number" id="expense-amount" v-model.number="newTransaction.amount" min="0" step="0.01" required>
      </div>
      <div class="form-group">
        <label for="expense-receipt">Foto Struk (Opsional):</label>
        <input type="file" id="expense-receipt" @change="handleFileUpload" accept="image/*">
        <small v-if="selectedFile">{{ selectedFile.name }} dipilih</small>
      </div>
      <button type="submit" class="submit-button">Tambah Pengeluaran</button>
    </form>

    <hr>

    <h3>Daftar Pengeluaran Anda</h3>
    <div v-if="expenses.length > 0" class="transaction-list">
      <table>
        <thead>
          <tr>
            <th>Tanggal</th>
            <th>Deskripsi</th>
            <th class="text-right">Jumlah</th>
            <th>Struk</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="expense in expenses" :key="expense.ID">
            <td>{{ new Date(expense.date).toLocaleDateString('id-ID') }}</td>
            <td>{{ expense.description }}</td>
            <td class="text-right">Rp {{ expense.amount.toLocaleString('id-ID') }}</td>
            <td>
              <a v-if="expense.receiptUrl" :href="getImageUrl(expense.receiptUrl)" target="_blank">
                <img :src="getImageUrl(expense.receiptUrl)" alt="Struk Pengeluaran" class="receipt-thumbnail">
              </a>
              <span v-else>Tidak Ada</span>
            </td>
            <td>
              <button @click="openEditModal(expense)" class="btn btn-edit">Edit</button>
              <button @click="deleteTransaction(expense.ID)" class="btn btn-delete">Hapus</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p>Tidak ada pengeluaran yang ditemukan.</p>
    </div>

    <p v-if="error" class="error-message">{{ error }}</p>

    <div v-if="showEditModal" class="modal-overlay">
      <div class="modal-content">
        <h3>Edit Pengeluaran</h3>
        <form @submit.prevent="saveEditedTransaction">
          <div class="form-group">
            <label for="edit-date">Tanggal:</label>
            <input type="date" id="edit-date" v-model="editingTransaction.date" required>
          </div>
          <div class="form-group">
            <label for="edit-description">Deskripsi:</label>
            <input type="text" id="edit-description" v-model="editingTransaction.description" required>
          </div>
          <div class="form-group">
            <label for="edit-amount">Jumlah:</label>
            <input type="number" id="edit-amount" v-model.number="editingTransaction.amount" min="0" step="0.01" required>
          </div>
          <div class="form-group" v-if="editingTransaction.receiptUrl">
            <label>Struk Saat Ini:</label>
            <div class="receipt-preview">
              <a :href="getImageUrl(editingTransaction.receiptUrl)" target="_blank">
                <img :src="getImageUrl(editingTransaction.receiptUrl)" alt="Struk" class="receipt-thumbnail">
              </a>
              <button type="button" @click="removeReceipt" class="btn btn-delete btn-small">Hapus Struk</button>
            </div>
          </div>
          <div class="form-group">
            <label for="edit-receipt">Ganti/Tambah Struk (Opsional):</label>
            <input type="file" id="edit-receipt" @change="handleEditFileUpload" accept="image/*">
            <small v-if="selectedEditFile">{{ selectedEditFile.name }} dipilih</small>
          </div>
          <div class="modal-actions">
            <button type="submit" class="btn btn-primary">Simpan Perubahan</button>
            <button type="button" @click="closeEditModal" class="btn btn-secondary">Batal</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2'; // Impor SweetAlert2

export default {
  name: 'ExpensePage',
  data() {
    return {
      expenses: [],
      newTransaction: {
        date: new Date().toISOString().split('T')[0],
        description: '',
        amount: 0,
        type: 'expense',
      },
      selectedFile: null,
      error: null,

      showEditModal: false,
      editingTransaction: {
        id: null,
        date: '',
        description: '',
        amount: 0,
        type: 'expense',
        receiptUrl: '',
      },
      selectedEditFile: null,
    };
  },
  methods: {
    getImageUrl(relativePath) {
      return `https://api.pala.linksoftindo.com${relativePath}`;
    },

    async apiCall(url, method = 'GET', data = null, isFormData = false) {
      const token = localStorage.getItem('token');
      if (!token) {
        this.$router.push('/login');
        // Gunakan SweetAlert2 untuk pesan error token
        Swal.fire({
          icon: 'error',
          title: 'Akses Ditolak!',
          text: 'Anda perlu login untuk mengakses halaman ini.',
          confirmButtonText: 'OK'
        });
        throw new Error('No token found, redirecting to login.');
      }

      const headers = {
        Authorization: `Bearer ${token}`,
      };

      if (!isFormData) {
        headers['Content-Type'] = 'application/json';
      }

      try {
        const config = {
          url,
          method,
          headers,
          data: data,
        };

        const response = await axios(config);
        return response.data;
      } catch (err) {
        this.error = err.response && err.response.data && err.response.data.error
          ? err.response.data.error
          : `Terjadi kesalahan: ${err.message}`;
        console.error('API Call Error:', err.response || err);
        // Tampilkan error menggunakan SweetAlert2
        Swal.fire({
          icon: 'error',
          title: 'Gagal!',
          text: this.error,
          confirmButtonText: 'OK'
        });
        throw err;
      }
    },

    async fetchTransactions() {
      try {
        this.error = null;
        this.expenses = await this.apiCall('https://api.pala.linksoftindo.com/api/transactions/?type=expense&userID=true', 'GET');
      } catch (err) {
        this.expenses = [];
      }
    },

    handleFileUpload(event) {
      this.selectedFile = event.target.files[0];
    },

    async addTransaction() {
      try {
        this.error = null;
        const transactionResponse = await this.apiCall(
          'https://api.pala.linksoftindo.com/api/transactions/',
          'POST',
          this.newTransaction
        );

        const newTransactionId = transactionResponse.data.ID;

        if (this.selectedFile) {
          const formData = new FormData();
          formData.append('receipt', this.selectedFile);

          await this.apiCall(
            `https://api.pala.linksoftindo.com/api/transactions/${newTransactionId}/receipt`,
            'POST',
            formData,
            true
          );
          // Notifikasi sukses menggunakan SweetAlert2
          Swal.fire({
            icon: 'success',
            title: 'Berhasil!',
            text: 'Pengeluaran dan struk berhasil ditambahkan!',
            timer: 2000,
            showConfirmButton: false
          });
        } else {
          // Notifikasi sukses menggunakan SweetAlert2
          Swal.fire({
            icon: 'success',
            title: 'Berhasil!',
            text: 'Pengeluaran berhasil ditambahkan!',
            timer: 1500,
            showConfirmButton: false
          });
        }

        this.fetchTransactions();
        this.newTransaction.description = '';
        this.newTransaction.amount = 0;
        this.newTransaction.date = new Date().toISOString().split('T')[0];
        this.selectedFile = null;
        const fileInput = document.getElementById('expense-receipt');
        if (fileInput) {
          fileInput.value = '';
        }
      } catch (err) {
        console.error('Error adding expense:', err);
      }
    },

    openEditModal(transaction) {
      this.editingTransaction = { ...transaction };
      this.editingTransaction.date = new Date(transaction.date).toISOString().split('T')[0];
      this.selectedEditFile = null;
      const editFileInput = document.getElementById('edit-receipt');
      if (editFileInput) {
        editFileInput.value = '';
      }
      this.showEditModal = true;
    },

    closeEditModal() {
      this.showEditModal = false;
      this.editingTransaction = {
        id: null,
        date: new Date().toISOString().split('T')[0],
        description: '',
        amount: 0,
        type: 'expense',
        receiptUrl: '',
      };
      this.selectedEditFile = null;
      this.error = null;
    },

    handleEditFileUpload(event) {
      this.selectedEditFile = event.target.files[0];
    },

    async saveEditedTransaction() {
      try {
        this.error = null;
        const transactionDetailsPayload = {
          description: this.editingTransaction.description,
          amount: parseFloat(this.editingTransaction.amount),
          date: this.editingTransaction.date,
          type: this.editingTransaction.type,
          receiptUrl: this.editingTransaction.receiptUrl,
        };

        await this.apiCall(
          `https://api.pala.linksoftindo.com/api/transactions/${this.editingTransaction.ID}`,
          'PUT',
          transactionDetailsPayload
        );

        if (this.selectedEditFile) {
          const formData = new FormData();
          formData.append('receipt', this.selectedEditFile);

          await this.apiCall(
            `https://api.pala.linksoftindo.com/api/transactions/${this.editingTransaction.ID}/receipt`,
            'POST',
            formData,
            true
          );
          // Notifikasi sukses menggunakan SweetAlert2
          Swal.fire({
            icon: 'success',
            title: 'Berhasil!',
            text: 'Pengeluaran dan struk berhasil diperbarui!',
            timer: 2000,
            showConfirmButton: false
          });
        } else {
          // Notifikasi sukses menggunakan SweetAlert2
          Swal.fire({
            icon: 'success',
            title: 'Berhasil!',
            text: 'Pengeluaran berhasil diperbarui!',
            timer: 1500,
            showConfirmButton: false
          });
        }

        this.closeEditModal();
        this.fetchTransactions();
      } catch (err) {
        console.error('Error saving edited expense:', err);
      }
    },

    async removeReceipt() {
      // Ganti `confirm` dengan SweetAlert2
      const result = await Swal.fire({
        title: 'Anda Yakin?',
        text: "Anda yakin ingin menghapus struk ini? Tindakan ini tidak dapat dikembalikan!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya, Hapus Struk!',
        cancelButtonText: 'Batal'
      });

      if (result.isConfirmed) {
        try {
          this.error = null;
          const payload = { ...this.editingTransaction, receiptUrl: '' };

          await this.apiCall(
            `https://api.pala.linksoftindo.com/api/transactions/${this.editingTransaction.ID}`,
            'PUT',
            payload
          );

          this.editingTransaction.receiptUrl = '';
          // Notifikasi sukses menggunakan SweetAlert2
          Swal.fire(
            'Dihapus!',
            'Struk berhasil dihapus.',
            'success'
          );
          this.fetchTransactions();
        } catch (err) {
          console.error('Error removing receipt:', err);
        }
      }
    },

    async deleteTransaction(transactionId) {
      // Ganti `confirm` dengan SweetAlert2
      const result = await Swal.fire({
        title: 'Anda Yakin?',
        text: "Anda tidak akan dapat mengembalikan ini!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya, Hapus!',
        cancelButtonText: 'Batal'
      });

      if (result.isConfirmed) {
        try {
          this.error = null;
          await this.apiCall(`https://api.pala.linksoftindo.com/api/transactions/${transactionId}`, 'DELETE');

          // Notifikasi sukses hapus menggunakan SweetAlert2
          Swal.fire(
            'Dihapus!',
            'Pengeluaran Anda telah dihapus.',
            'success'
          );
          this.fetchTransactions();
        } catch (err) {
          console.error('Error deleting expense:', err);
        }
      }
    }
  },
  async created() {
    await this.fetchTransactions();
  }
};
</script>

<style scoped>
/* Styling dasar untuk halaman pengeluaran */
.expense-page {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h2, h3 {
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

hr {
  border: 0;
  border-top: 1px solid #eee;
  margin: 30px 0;
}

/* Styling untuk formulir transaksi */
.transaction-form {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  color: #555;
  font-weight: bold;
}

.form-group input[type="date"],
.form-group input[type="text"],
.form-group input[type="number"],
.form-group input[type="file"] {
  width: calc(100% - 22px);
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

.submit-button {
  background-color: #f44336; /* Merah */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  width: 100%;
  transition: background-color 0.3s ease;
}

.submit-button:hover {
  background-color: #d32f2f;
}

/* Styling untuk daftar transaksi (tabel) */
.transaction-list table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden; /* Memastikan sudut membulat diterapkan ke konten */
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.transaction-list th,
.transaction-list td {
  border: 1px solid #eee;
  padding: 12px 15px;
  text-align: left;
}

.transaction-list th {
  background-color: #f2f2f2;
  font-weight: bold;
  color: #666;
}

.transaction-list tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.transaction-list tbody tr:hover {
  background-color: #f1f1f1;
}

.error-message {
  color: #d9534f; /* Merah */
  background-color: #f2dede;
  border: 1px solid #ebccd1;
  padding: 10px;
  border-radius: 4px;
  text-align: center;
}

/* Gaya untuk thumbnail struk */
.receipt-thumbnail {
  width: 50px; /* Ukuran thumbnail */
  height: auto;
  border-radius: 4px;
  cursor: pointer;
  vertical-align: middle;
}

/* --- Gaya Baru untuk Modal dan Tombol Aksi --- */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6); /* Latar belakang gelap */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Pastikan modal di atas konten lain */
}

.modal-content {
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  width: 90%;
  max-width: 500px; /* Lebar maksimum modal */
}

.modal-content h3 {
  text-align: center;
  margin-bottom: 25px;
  color: #333;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px; /* Spasi antar tombol */
  margin-top: 25px;
}

/* Gaya dasar untuk semua tombol aksi (edit, delete, primary, secondary) */
.btn {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9em;
  margin-right: 5px; /* Spasi antar tombol di tabel */
}

/* Gaya khusus untuk tombol Edit */
.btn-edit {
  background-color: #2196F3; /* Biru */
  color: white;
}

.btn-edit:hover {
  background-color: #0b7dda;
}

/* Gaya khusus untuk tombol Hapus */
.btn-delete {
  background-color: #f44336; /* Merah */
  color: white;
}

.btn-delete:hover {
  background-color: #da190b;
}

/* Gaya khusus untuk tombol "Simpan Perubahan" di modal */
.btn-primary {
  background-color: #4CAF50; /* Hijau */
  color: white;
}

/* Gaya khusus untuk tombol "Batal" di modal */
.btn-secondary {
  background-color: #f0f0f0;
  color: #333;
  border: 1px solid #ccc;
}

/* Gaya untuk pratinjau struk di modal edit */
.receipt-preview {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 5px;
}

.btn-small {
  padding: 5px 8px;
  font-size: 0.8em;
}

.text-right {
  text-align: right!important;
}

.expense-page {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h2, h3 {
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

hr {
  border: 0;
  border-top: 1px solid #eee;
  margin: 30px 0;
}

.transaction-form {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  color: #555;
  font-weight: bold;
}

.form-group input[type="date"],
.form-group input[type="text"],
.form-group input[type="number"],
.form-group input[type="file"] {
  width: calc(100% - 22px);
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

.submit-button {
  background-color: #f44336;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  width: 100%;
  transition: background-color 0.3s ease;
}

.submit-button:hover {
  background-color: #d32f2f;
}

.transaction-list table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.transaction-list th,
.transaction-list td {
  border: 1px solid #eee;
  padding: 12px 15px;
  text-align: left;
}

.transaction-list th {
  background-color: #f2f2f2;
  font-weight: bold;
  color: #666;
}

.transaction-list tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.transaction-list tbody tr:hover {
  background-color: #f1f1f1;
}

.error-message {
  color: #d9534f;
  background-color: #f2dede;
  border: 1px solid #ebccd1;
  padding: 10px;
  border-radius: 4px;
  text-align: center;
}

.receipt-thumbnail {
  width: 50px;
  height: auto;
  border-radius: 4px;
  cursor: pointer;
  vertical-align: middle;
}

.text-right {
  text-align: right;
}

/* --- Gaya Baru untuk Modal dan Tombol Aksi --- */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  width: 90%;
  max-width: 500px;
}

.modal-content h3 {
  text-align: center;
  margin-bottom: 25px;
  color: #333;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 25px;
}

.btn {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9em;
  margin-right: 5px;
}

.btn-edit {
  background-color: #2196F3;
  color: white;
}

.btn-edit:hover {
  background-color: #0b7dda;
}

.btn-delete {
  background-color: #f44336;
  color: white;
}

.btn-delete:hover {
  background-color: #da190b;
}

.btn-primary {
  background-color: #4CAF50;
  color: white;
}

.btn-secondary {
  background-color: #f0f0f0;
  color: #333;
  border: 1px solid #ccc;
}

.receipt-preview {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 5px;
}

.btn-small {
  padding: 5px 8px;
  font-size: 0.8em;
}
</style>